var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('LearningObjectiveViewer',{model:{value:(_vm.value.body.contents),callback:function ($$v) {_vm.$set(_vm.value.body, "contents", $$v)},expression:"value.body.contents"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }